export default __webpack_public_path__ + "static/media/bachansing.a878ee12.png";